import {gsap} from 'gsap'

export const header = () => {
  const
    animations = {
      accordions: () => import('./../animations/accordions')
    },
    helpers = {
      blockNativeScroll: () => import('./../helpers/block-native-scroll'),
      blockSmoothScroll: () => import('./../helpers/block-smooth-scroll')
    },
    phasesOverlay = document.querySelector('.phases-overlay'),
    institutionalTrigger = document.querySelector('.institutional-trigger'),
    institutionalTriggerSVG = institutionalTrigger ? institutionalTrigger.querySelector('svg') : null,
    institutionalMenu = document.querySelector('.menu-go-institutional'),
    logo = document.querySelector('#logo'),
    headerInnerELs = document.querySelectorAll('.nav-onboarding > *'),
    closeInstitutionalAnimation = () => {
      helpers.blockSmoothScroll().then(module => module.blockSmoothScroll(false))
      helpers.blockNativeScroll().then(module => module.blockNativeScroll(false))

      gsap.to(institutionalTriggerSVG, {
        rotate: 0
      })

      gsap.to(institutionalMenu, {
        x: '100%',
        duration: .7,
        ease: 'expo.out',
        onComplete: () => gsap.set(institutionalMenu, {
          autoAlpha: 0
        })
      })

      gsap.to([logo, headerInnerELs], {
        opacity: 1,
        duration: .2
      })
    }

  if (phasesOverlay) {
    const
      trigger = document.querySelector('.phases-trigger'),
      list = phasesOverlay.querySelector('.phases-overlay__list'),
      closes = phasesOverlay.querySelectorAll('.phases-overlay__close'),
      closeSVG = phasesOverlay.querySelector('.phases-overlay__close__svg'),
      accordions = document.querySelectorAll('.phases-overlay__accordion')

    trigger.addEventListener('click', (event) => {
      event.preventDefault()

      helpers.blockSmoothScroll().then(module => module.blockSmoothScroll(true))
      helpers.blockNativeScroll().then(module => module.blockNativeScroll(true))

      gsap.to(phasesOverlay, {
        onStart: () => phasesOverlay.classList.add('phases-overlay--open'),
        autoAlpha: 1,
        duration: .3
      })

      gsap.to(list, {
        x: 0,
        y: 0,
        duration: .8,
        ease: 'power2.inOut',
        onComplete: () => {
          gsap.to(closeSVG, {
            autoAlpha: 1,
            scale: 1,
            rotate: 0,
            duration: .3
          })
        }
      })
    })

    if (closes.length > 0) {
      for (const close of closes) {
        close.addEventListener('click', () => {
          helpers.blockSmoothScroll().then(module => module.blockSmoothScroll(false))
          helpers.blockNativeScroll().then(module => module.blockNativeScroll(false))

          gsap.to(closeSVG, {
            onStart: () => phasesOverlay.classList.remove('phases-overlay--open'),
            autoAlpha: 0,
            scale: .5,
            rotate: '45deg',
            duration: .1,
            onComplete: () => {
              gsap.to(list, {
                x: window.innerWidth > 1023 ? '140%' : 0,
                y: window.innerWidth > 1023 ? 0 : '110%',
                duration: .5,
                ease: 'power2.inOut'
              })

              gsap.to(phasesOverlay, {
                autoAlpha: 0,
                duration: .1,
                delay: .6
              })
            }
          })
        })
      }
    }

    if (accordions.length > 0) {
      let activeChildTrigger = null

      for (const accordion of accordions) {
        const
          trigger = accordion.querySelector('.phases-overlay__accordion__trigger'),
          content = accordion.querySelector('.phases-overlay__accordion__content'),
          activeSubItem = accordion.querySelector('li .line-through')

        if (activeSubItem) {
          activeChildTrigger = trigger
        }

        let isOpen = false

        trigger.addEventListener('click', () => {
          const alreadyOpenAccordion = document.querySelector('.phases-overlay__accordion--open')
          isOpen = !isOpen

          /* close already open accordion */
          if (alreadyOpenAccordion && alreadyOpenAccordion !== accordion) {
            alreadyOpenAccordion.querySelector('.phases-overlay__accordion__trigger').click()
          }

          animations.accordions().then(module => module.accordions(isOpen, content, .7, 'power2.inOut', () => {
            accordion.classList.toggle('phases-overlay__accordion--open')
          }, null, null))
        })
      }

      if (activeChildTrigger) {
        activeChildTrigger.click()
      }
    }
  }

  if (institutionalTrigger) {
    let isOpen = false

    institutionalTrigger.addEventListener('click', () => {
      isOpen = !isOpen

      if (isOpen) {
        helpers.blockSmoothScroll().then(module => module.blockSmoothScroll(true))
        helpers.blockNativeScroll().then(module => module.blockNativeScroll(true))

        gsap.to([logo, headerInnerELs], {
          opacity: 0,
          duration: .2
        })

        gsap.to(institutionalTriggerSVG, {
          rotate: -135
        })

        gsap.set(institutionalMenu, {
          autoAlpha: 1
        })

        gsap.to(institutionalMenu, {
          x: 0
        })
      } else {
        closeInstitutionalAnimation()
      }
    })
  }
}
